import SessionStorage from './SessionStorage';

export const flowDataModule = {
    setInSession: async (data: any) => {
        if (data && data.FirstName) {
            data.FirstName =
                data.FirstName.substring(0, 1).toUpperCase() +
                data.FirstName.substring(1).toLowerCase();
        }

        await SessionStorage.setCipherWithCurrentScope('flowData', data ?? {});

        // @ts-ignore
        if (window.digitalData && window.digitalData.analyticsData) {
            // @ts-ignore
            window.digitalData.analyticsData.flowData = data ?? {};
        }
    },

    getFromSession: async () => {
        return await SessionStorage.tryGetCipher('flowData', {});
    },

    updateInSession: async function (data: any) {
        const sessionObject = await this.getFromSession() || {};
        for (const propertyName in data) {
            sessionObject[propertyName] = data[propertyName];
        }

        await this.setInSession(sessionObject);
    },
};